.chart-container-data-container{
    display: flex;
}

.chart-container-data-container-top{
    flex-direction: column;
}

.chart-container-kpi-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: absolute;
    gap: 30px;
    padding-top: 20px;
    padding-left: 10px;
}

.chart-container-kpi-container-top {
    flex-direction: row;
    justify-content: space-evenly;
    position: relative;
}

.chart-container-spacer{
    flex-grow: 1;
}
